import Tooltip from '@betterfunnel/ui-core/Tooltip';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

interface SettingsHelpTooltipProps {
  /** The content to display inside the tooltip */
  text: ReactNode;
  /** Size of the question mark icon */
  iconSize?: 'sm' | 'md' | 'lg';
  /** Placement direction for the tooltip */
  placement?: 'top' | 'bottom' | 'left' | 'right';
  /** Additional class name for the icon */
  className?: string;
}

const SettingsHelpTooltip = ({
  text,
  iconSize = 'md',
  placement = 'bottom',
  className = '',
}: SettingsHelpTooltipProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
  };

  return (
    <Tooltip text={text} placement={placement} tooltipClassName="max-w-xs">
      <QuestionMarkCircleIcon
        className={`cursor-help text-gray-400 transition-colors hover:text-gray-600 ${
          sizeClasses[iconSize]
        } ${className}`}
      />
    </Tooltip>
  );
};

export default SettingsHelpTooltip;
